export const MAIL_ID = 'trimble-insights-dev-ug@trimble.com';
export const PAGE_SIZE = 25;
